'use client';

import Bugsnag from '@bugsnag/js';
// eslint-disable-next-line @alltrails/custom/react-imports
import React, { type ReactNode } from 'react';

// prevent "Bugsnag.getPlugin() was called before Bugsnag.start()" errors in tests
const plugin = '_client' in Bugsnag ? Bugsnag.getPlugin('react') : null;
const BugsnagErrorBoundary = plugin?.createErrorBoundary(React);

type Props = {
  children: ReactNode;
};

const ErrorBoundary = ({ children }: Props) => {
  if (BugsnagErrorBoundary) {
    return <BugsnagErrorBoundary>{children}</BugsnagErrorBoundary>;
  }

  return <>{children}</>;
};

export default ErrorBoundary;
